import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import SvgChevronDown from 'src/components/Svgs/SvgChevronDown'
import SvgChevronUp from 'src/components/Svgs/SvgChevronUp'
import { css } from 'styled-components'

export enum SortableTableHeaderAlignment {
  LeftAligned = 'left-aligned',
  RightAligned = 'right-aligned',
}

interface SortableTableHeaderProps {
  className?: string
  alignment: SortableTableHeaderAlignment
  label?: React.ReactElement
  sortDescending?: boolean
  isSorted?: boolean
  noLeftPadding?: boolean
  noRightPadding?: boolean
  onClick?: () => void
}

const SortableTableHeader: (
  props: SortableTableHeaderProps,
) => React.ReactElement = (props): React.ReactElement => {
  return (
    <div
      className={props.className}
      onClick={props.onClick}
      onKeyPress={props.onClick}
      role="button"
      tabIndex={0}
      aria-label={'sortable table header'}
      css={css`
        display: table-cell;
        ${getFontCss(
          12,
          themeConstants.colors.font_primary,
          styleConstants.fontFamilies.medium,
        )}

        ${props.onClick !== undefined &&
        css`
          cursor: pointer;
        `}
        
        ${!!props.isSorted &&
        css`
          color: ${themeConstants.colors.cta};
        `}
        
        padding: 24px 30px 24px 0px;
        &:first-child {
          padding: 24px 30px 24px 40px;
        }

        ${!!props.noLeftPadding &&
        css`
          padding-left: 0px !important;
        `}

        ${!!props.noRightPadding &&
        css`
          padding-right: 0px !important;
        `}

        &:last-child {
          padding: 24px 40px 24px 0px;
        }

        ${getBreakpointDown(breakpointSizes.SM)(css`
          padding: 24px 10px 24px 0px;

          &:first-child {
            padding: 24px 10px 24px 40px;
          }

          &:last-child {
            padding: 24px 40px 24px 0px;
          }

          ${!!props.noLeftPadding &&
          css`
            padding-left: 0px !important;
          `}

          ${!!props.noRightPadding &&
          css`
            padding-right: 0px !important;
          `}
        `)}
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          white-space: nowrap;
          height: 16px;

          ${props.alignment === SortableTableHeaderAlignment.RightAligned &&
          css`
            justify-content: flex-end;
          `}
        `}
      >
        {props.label}
        <SvgChevronDown
          css={css`
            transform-origin: center;
            transform: scale(0.6);
            display: none;
            min-width: 24px;
            ${!!props.isSorted &&
            !!props.sortDescending &&
            css`
              display: block;
            `}
          `}
        />
        <SvgChevronUp
          css={css`
            transform-origin: center;
            transform: scale(0.6);
            display: none;
            min-width: 24px;
            ${!!props.isSorted &&
            !props.sortDescending &&
            css`
              display: block;
            `}
          `}
        />
      </div>
    </div>
  )
}

export default SortableTableHeader
